import { WemapSDK } from '../types/Wemap';

let cachedWemapSDKPromise: Promise<WemapSDK> | null = null;

export function loadWemapSDK(): Promise<WemapSDK> {
    if (cachedWemapSDKPromise) {
        return cachedWemapSDKPromise;
    }

    cachedWemapSDKPromise = (async () => {
        if ((window as { wemap?: WemapSDK }).wemap) {
            return (window as { wemap: WemapSDK }).wemap;
        }

        await new Promise<void>((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://livemap.getwemap.com/js/sdk.min.js';
            script.async = true;
            script.onload = () => {
                resolve();
            };
            script.onerror = () => {
                reject(new Error('Wemap SDK did not load'));
            };
            document.head.appendChild(script);
        });

        if (!(window as { wemap?: WemapSDK }).wemap) {
            throw new Error('Wemap SDK loaded but not available on window');
        }

        return (window as { wemap: WemapSDK }).wemap;
    })();

    return cachedWemapSDKPromise;
}
